/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_Free_AudienceInputs */



/**
* | output |
* | --- |
* | "For occasional projects" |
*
* @param {Signup_Plan_Free_AudienceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_free_audience = /** @type {((inputs?: Signup_Plan_Free_AudienceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_Free_AudienceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "de") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "it") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "ru") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "es") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "ja") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "hi") return /** @type {LocalizedString} */ ("For occasional projects")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("For occasional projects")
	return /** @type {LocalizedString} */ ("For occasional projects")
});